import apiClient from './apiClient';

export interface TeamMember {
  id: number;
  name: string;
  email: string;
  employee_code: string;
  job_position: string | null;
  department: string | null;
  roles: string[];
  hours_this_week: number;
  pending_timesheets: number;
  approved_this_week: number;
}

export interface TeamResponse {
  team: TeamMember[];
  total: number;
}

/**
 * Team API service
 */
export const teamApi = {
  /**
   * Get current user's direct reports (team members)
   */
  getMyTeam: async (): Promise<TeamResponse> => {
    return apiClient.get<TeamResponse>('/users/my-team');
  },
};

export default teamApi;
